import { Role } from '@avgrp/shared';

/**
 * Role hierarchy levels — higher number = more privileges.
 */
export const ROLE_HIERARCHY: Record<Role, number> = {
  [Role.ADMIN]: 4,
  [Role.MANAGER]: 3,
  [Role.SUPERVISOR]: 2,
  [Role.EMPLOYEE]: 1,
};

/**
 * Check if a user's role meets or exceeds the required minimum role.
 */
export function hasMinRole(userRole: Role | string | undefined, minRole: Role): boolean {
  if (!userRole) return false;
  const userLevel = ROLE_HIERARCHY[userRole as Role] ?? 0;
  const requiredLevel = ROLE_HIERARCHY[minRole];
  return userLevel >= requiredLevel;
}
